<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2XUP19/tc-custom/9781488011931.jpg?1725275644749" alt="This image is the cover for the book Texan Takes a Wife, Texas Cattleman's Club: Blackmail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texan Takes a Wife, Texas Cattleman's Club: Blackmail
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: It was just supposed to be a temporary tryst with a sexy Texan . . .</b><br/><br/>All it takes is a daring out-of-character ride on a mechanical bull to send Erin Sinclair straight into the arms of one fine-looking cowboy. With Royal, Texas, on edge over the criminal targeting their secrets, she needs to blow off steam. Dan Hunt is happy to give the ex-nanny the time of her life, but the rich rancher insists he doesn’t do relationships.<br/><br/>And Erin’s fine with that—though she can’t help the stirring in her heart as she discovers Dan’s penchant for rescuing animals. But with Erin leaving Royal in a matter of weeks, it can only be a no-strings affair. Even if it feels like it could be the commitment of a lifetime . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlene Sands
      </h2>
      
      <p class="authorDescription body article">Charlene Sands is a USA Today bestselling author of 35&#160;contemporary and historical romances. She&#39;s&#160;been honored with The National Readers&#39; Choice Award,&#160;Booksellers Best Award and Cataromance Reviewer&#39;s Choice Award.&#160;She loves babies,chocolate and&#160;thrilling love stories.Take a peek at her&#160;bold,&#160;sexy&#160;heroes and<I>&#160;real good men!</I>&#160;&#160;<a href="http://www.charlenesands.com">www.charlenesands.com</a>&#160;&#160;and Facebook</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d0728e1